import {
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip,
} from 'chart.js'
import { WordCloudController, WordElement } from 'chartjs-chart-wordcloud'

import { drilldownLegendGapPlugin } from './drilldownChartTheme'

/**
 * Registers every Chart.js controller/element/scale the drill-down charts use.
 * Importing this module once (via the charts barrel) is enough — registration
 * is idempotent, so repeated imports are safe.
 */
let registered = false

export function registerDrillDownCharts(): void {
  if (registered) return
  ChartJS.register(
    ArcElement,
    BarController,
    BarElement,
    LineController,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Filler,
    Legend,
    Tooltip,
    WordCloudController,
    WordElement,
    drilldownLegendGapPlugin,
  )
  registered = true
}

registerDrillDownCharts()
